import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import styles from './ProjectModalNew.module.scss';
import '@github/relative-time-element';
import ProjectModalGallery from './ProjectModalGallery.tsx';
import ProjectModalQuestions from './ProjectModalQuestions.tsx';
import ModalOverlay from '../../../UI/ModalOverlay/ModalOverlay.tsx';
import MapPinIcon from '../../../../assets/iconsTsx/MapPinIcon.tsx';
import CalendarIcon from '../../../../assets/iconsTsx/CalendarIcon.tsx';
import ClockIcon from '../../../../assets/iconsTsx/ClockIcon.tsx';

interface ProjectModalNewProps {
  project: {
    id: string | number;
    name: string;
    description?: string;
    zone?: string;
    startDate?: string;
    endDate?: string;
    createdAt?: string;
    proyecto_images?: Array<{ image: string }>;
  };
  closeModal: () => void;
  projectQuestionsForItem: any[];
  myPerson: boolean;
  userData: any;
}

const modal = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { delay: 0.1 },
  },
};

const ProjectModalNew: React.FC<ProjectModalNewProps> = ({
  project,
  closeModal,
  projectQuestionsForItem,
  myPerson,
  userData
}) => {
  return (
    <ModalOverlay isOpen={true} onClose={closeModal} zIndex={1000}>
      <motion.div
        className={styles.modal_container}
        variants={modal}
        initial="hidden"
        animate="visible"
        exit="hidden"
      >
        <div className={styles.modal_header}>
          <div className={styles.modal_header_content}>
            <div className={styles.modal_badge}>
              <span>Proyecto</span>
            </div>
          </div>
          <button className={styles.modal_close} onClick={closeModal}>
            <X size={24} />
          </button>
        </div>

        <div className={styles.modal_content}>
          <ProjectModalGallery images={project.proyecto_images || []} name={project.name} />

          <div className={styles.info_section}>
            <div className={styles.info_content}>
              <h2 className={styles.info_title}>{project.name}</h2>

              {project.description && (
                <p className={styles.info_description}>{project.description}</p>
              )}

              {(project.zone || project.startDate || project.endDate || project.createdAt) && (
                <div className={styles.info_details}>
                  {project.zone && (
                    <div className={styles.info_detail}>
                      <MapPinIcon className={styles.info_detail_icon} />
                      <span>{project.zone}</span>
                    </div>
                  )}

                  {(project.startDate || project.endDate) && (
                    <div className={styles.info_detail}>
                      <CalendarIcon className={styles.info_detail_icon} />
                      <span>
                        {project.startDate && new Date(project.startDate).toLocaleDateString('es-ES')}
                        {project.startDate && project.endDate && ' - '}
                        {project.endDate && new Date(project.endDate).toLocaleDateString('es-ES')}
                      </span>
                    </div>
                  )}

                  {project.createdAt && (
                    <div className={styles.info_detail}>
                      <ClockIcon className={styles.info_detail_icon} />
                      <span>
                        <relative-time lang="es" tense="past" datetime={project.createdAt}></relative-time>
                      </span>
                    </div>
                  )}
                </div>
              )}

              <ProjectModalQuestions
                questions={projectQuestionsForItem}
                myPerson={myPerson}
                projectId={project.id}
              />
            </div>
          </div>
        </div>
      </motion.div>
    </ModalOverlay>
  );
};

export default ProjectModalNew;
